import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const translations = {
  es: {
    title: 'Aviso de Cookies',
    message: 'Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Al continuar navegando, aceptas el uso de cookies.',
    moreInfo: 'Más información sobre cookies',
    reject: 'Rechazar y Salir',
    accept: 'Aceptar y Continuar'
  },
  en: {
    title: 'Cookie Notice',
    message: 'We use cookies to improve your experience on our website. By continuing to browse, you accept the use of cookies.',
    moreInfo: 'More information about cookies',
    reject: 'Reject and Leave',
    accept: 'Accept and Continue'
  },
  de: {
    title: 'Cookie-Hinweis',
    message: 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Wenn Sie weiter surfen, akzeptieren Sie die Verwendung von Cookies.',
    moreInfo: 'Weitere Informationen zu Cookies',
    reject: 'Ablehnen und Verlassen',
    accept: 'Akzeptieren und Fortfahren'
  },
  fr: {
    title: 'Avis sur les Cookies',
    message: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant à naviguer, vous acceptez l\'utilisation des cookies.',
    moreInfo: 'Plus d\'informations sur les cookies',
    reject: 'Refuser et Quitter',
    accept: 'Accepter et Continuer'
  },
  it: {
    title: 'Avviso sui Cookie',
    message: 'Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito. Continuando a navigare, accetti l\'uso dei cookie.',
    moreInfo: 'Maggiori informazioni sui cookie',
    reject: 'Rifiuta ed Esci',
    accept: 'Accetta e Continua'
  }
};

export const CookieConsentBanner = () => {
  const { language } = useLanguage();
  const t = translations[language] || translations.es;
  
  const [cookieConsent, setCookieConsent] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('cookieConsent');
    }
    return null;
  });

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setCookieConsent('accepted');
  };

  const handleRejectCookies = () => {
    window.location.href = 'https://www.google.com';
  };

  if (cookieConsent !== null) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-lg mx-4 animate-in fade-in zoom-in duration-300">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            {t.title}
          </h3>
          <p className="text-gray-600 mb-4 leading-relaxed">
            {t.message}
          </p>
          <a 
            href="/cookies" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline text-sm mb-6 inline-block"
          >
            {t.moreInfo}
          </a>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mt-4">
            <Button
              variant="outline"
              onClick={handleRejectCookies}
              className="px-6 py-2 text-gray-700 border-gray-300 hover:bg-gray-100"
            >
              {t.reject}
            </Button>
            <Button
              onClick={handleAcceptCookies}
              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white"
            >
              {t.accept}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
